import React, { useState } from 'react';
import { Menu, MenuItem, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MenuItemType } from '../Header';
import { GridMenuHiddenDown } from '../Header/template';
import { GREEN_MAIN } from '../../theme/colors';

type Props = {
  items: MenuItemType[];
};

const DynamicMenu: React.FC<Props> = ({ items }) => {
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState<null | HTMLElement>(null);
  const [currentSubmenu, setCurrentSubmenu] = useState<MenuItemType[] | null>(null);
  const navigate = useNavigate();

  const handleNavigate = (link?: string) => {
    if (!link) return;
    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
    handleCloseSubmenu();
  };

  const handleOpenSubmenu = (event: React.MouseEvent<HTMLElement>, submenu: MenuItemType[]) => {
    setSubmenuAnchorEl(event.currentTarget);
    setCurrentSubmenu(submenu);
  };

  const handleCloseSubmenu = () => {
    setSubmenuAnchorEl(null);
    setCurrentSubmenu(null);
  };

  const isPathActive = (link?: string): boolean => {
    return !!link && window.location.pathname === link;
  };

  const isSubmenuActive = (submenu?: MenuItemType[]): boolean => {
    return !!submenu?.some((item) => isPathActive(item.link));
  };

  return (
    <Box display="flex" alignItems="center">
      {items.map((item, index) => {
        const isActive = isPathActive(item.link) || isSubmenuActive(item.submenu);
        const handleClick = item.submenu
          ? (e: React.MouseEvent<HTMLElement>) => handleOpenSubmenu(e, item.submenu!)
          : () => handleNavigate(item.link);

        return (
          <GridMenuHiddenDown
            key={index}
            breackpoint="md"
            item
            // margin="0 5px"
            sx={{
              cursor: 'pointer',
              fontWeight: isActive ? 'bold' : undefined,
              color: GREEN_MAIN,
              whiteSpace: 'nowrap' 
            }}
            onClick={handleClick}
          >
            {item.nome}
          </GridMenuHiddenDown>
        );
      })}

      {currentSubmenu && (
        <Menu
          anchorEl={submenuAnchorEl}
          open={Boolean(submenuAnchorEl)}
          onClose={handleCloseSubmenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          {currentSubmenu.map((subItem, i) => (
            <MenuItem
              key={i}
              onClick={() => handleNavigate(subItem.link)}
              sx={{
                fontWeight: isPathActive(subItem.link) ? 'bold' : undefined,
                color: GREEN_MAIN,
                fontSize: '1em'
              }}
            >
              {subItem.nome}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
};

export default DynamicMenu;
